/**
 * @fileOverview
 * Vybit App Client Configuration
 * @copyright 2015-present Flatirontek LLC
 */

// Fallback to 'development' unless overridden
const env = (typeof window !== 'undefined' && typeof window.__VYBIT_CLIENT_ENV__ === 'string')
    ? window.__VYBIT_CLIENT_ENV__
    : (window?.location?.host.includes('staging') ? 'staging'
        : window?.location?.host.includes('cloud') ? 'cloud'
            : 'development');

const baseConfig = {
    wwwHost: "www.vybit.net",
    pwHost: "my.vybit.net",
    pwApiKey: "pk_live_51LKAizDGHpaPCWmyYRwmkbnJtYXMVF2IY0KJ8Yf1n6GURdVNQDul3heSgN3rQzBr8xj8yM124E8LIOgmvHtToI6I00ybSbFRBV",
    pwPricingTableId: "prctbl_1UDtzwDGHpaPCWmyRC0xWrxE",
    port: "",
    pwEnabled: false
};

const envConfig = {
    development: {
        ...baseConfig,
        hostname: "dev.vybit.net",
        wwwHost: "dev.www.vybit.net",
        pwHost: "dev.my.vybit.net",
        pwApiKey: "pk_test_51LKAizDGHpaPCWmyXPlXEcWtRHpZ5xsPHAdROZrERzCtawE9xBGv6vdcSGVbj3QQAsXAcEnvr98E0CO0fikeMs4j00iSXLTEXC",
        pwPricingTableId: "prctbl_1UF3mrDGHpaPCWmyhlND4QPY",  //test-mode Pro/Team/Business table (Oct 2026 lineup)
    },
    staging: {
        ...baseConfig,
        hostname: "staging.vybit.net",
        wwwHost: "staging.www.vybit.net",
        pwHost: "staging.my.vybit.net",
        port: "8420",
        pwApiKey: "pk_test_51LKAizDGHpaPCWmyXPlXEcWtRHpZ5xsPHAdROZrERzCtawE9xBGv6vdcSGVbj3QQAsXAcEnvr98E0CO0fikeMs4j00iSXLTEXC",
        pwPricingTableId: "prctbl_1UF3mrDGHpaPCWmyhlND4QPY",  //test-mode Pro/Team/Business table (Oct 2026 lineup)
    },
    production: {
        ...baseConfig,
        hostname: "vybit.net",
    },
    cloud: {
        ...baseConfig,
        hostname: "cloud.vybit.net",
    },
    common: {
        iOsSoundLib: "cdvfile://localhost/library/Sounds/",
        ratingSoakTime: 90 * 24 * 60 * 60,
    }
};

const config = envConfig[env];
const common = envConfig.common;

// Compute dynamic values
const serverDomain = config.port ? `${config.hostname}:${config.port}` : config.hostname;

// Exported Config
module.exports = {
    env,
    envConfig: envConfig,
    hostName: serverDomain,

    baseApiUrl: `https://${serverDomain}`,
    restApiUrl: `https://${serverDomain}/rest`,

    debug: env === "development" || env === "staging",

    webSocketUri: `https://${window?.location?.host || serverDomain}`,
    subscriptionUri: `https://${serverDomain}/stripe/v1`,

    soundLib: 'https://vybit.net/sounds',
    qrcodeLib: 'https://vybit.net/qrcodes',

    inactiveThreshold: 70, // seconds
    checkInterval: 60, // minutes

    defaultSoundKey: '4brgzvngimartu1d',

    firebase: {
        apiKey: "AIzaSyCShECylQBTYoy7pMH_aa87ESfyjAg908c",
        authDomain: "signin.vybit.net",
        iOsAuthDomain: "auth1.vybit.net",
        serviceAuthDomain: "app.vybit.net",
        databaseURL: "https://vybr-139921.firebaseio.com",
        projectId: "vybr-139921",
        storageBucket: "vybr-139921.appspot.com",
        messagingSenderId: "951851584565",
        appId: "1:951851584565:web:26f5764095598d9196b57c"
    },

    packageName: "com.vybit",
    dynamicLinkDomain: "signin.vybit.net",

    iOsSoundLib: common.iOsSoundLib,
    ratingSoakTime: common.ratingSoakTime,

    localSoundDir: (typeof cordova === "object")
        ? (cordova.platformId === "ios" ? common.iOsSoundLib : common.androidExternalSoundLib)
        : "",

    wwwHost: config.wwwHost,
    pwHost: config.pwHost,
    pwApiKey: config.pwApiKey,
    pwPricingTableId: config.pwPricingTableId,

    serviceAuth: {
        ifttt: {
            displayName: 'IFTTT',
            redirect_uri: "https://ifttt.com/channels/vybit/authorize"
        },
        zapier: {
            displayName: 'Zapier',
            redirect_uri: "https://zapier.com/dashboard/auth/oauth/return/App118849CLIAPI/"
        },
        integromat: {
            displayName: 'Make',
            redirect_uri: "https://www.make.com/oauth/cb/app"
        }
    },

    stripe: "https://billing.stripe.com/p/login/test_cN26qF1ip2hb1fq288",

    // Small helpers
    isDev: env === 'development',
    isStaging: env === 'staging',
    isProd: env === 'production' || env === 'cloud',
};
